<template>
  <v-container id="agency-detail" fluid tag="section">
    <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2" v-if="tabIndex == 0">Thông tin đại lý</div>
        <div class="font-weight-light card-title mt-2" v-if="tabIndex == 1">Danh sách đơn hàng</div>
        <div class="font-weight-light card-title mt-2" v-if="tabIndex == 2">Khách hàng đại lý</div>
        <div class="font-weight-light card-title mt-2" v-if="tabIndex == 3">Danh sách mã</div>
      </template>
      <v-tabs
        @change="changeTab"
        v-model="tabIndex"
        class="mt-3" color="primary"
      >
        <v-tab v-for="(tab, i) in tabs" :key="i">{{ tab }}</v-tab>
      </v-tabs>
      <validation-observer>
        <div class="header-group-btn header-group-btn--modify">
            <!-- <v-col cols="12" class="d-flex"> -->
          <v-menu
            :internal-activator="true"
            v-model="openMenu"
            content-class="menu__customer--filter no-contain overflow-visible"
            :close-on-content-click="false"
            v-if="tabIndex == 1"
          >
            <template v-slot:activator="{ on }">
              <v-btn style="margin-right: 10px;" color="primary" dark v-on="on">
                <span>Lọc theo điều kiện</span>
                <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <card-filter-form
              :filterForm="filterForm"
              :openMenu="openMenu"
              :filterAgencyStatusList="contactStatusAgency"
              :usersAgency="usersAgency"
            />
          </v-menu>
        <!-- </v-col> -->
          <v-btn
              color="primary"
              class="mr-3"
              dark
              @click="exportContactForAgency()"
              v-if="tabIndex == 2 && checkAuthorization('agency-admin_download')">Download
          </v-btn>

          <v-btn
            color="primary"
            class="mr-3"
            dark
            @click="clickAddOrder"
            v-if="tabIndex !== 3">
            <v-icon>mdi-plus</v-icon>Tạo đơn
          </v-btn>
        </div>
        <v-row class="px-4">
          <v-col cols="12" v-if="tabIndex === 0">
            <agency-detail-card />
          </v-col>

          <v-col cols="12" v-if="tabIndex === 1">
            <order-table-v1
              :orders="orders"
              :totalPrice="totalPrice"
              :contactStatusAgency="contactStatusAgency"
            />

            <v-col cols="12" sm="6">
              <v-pagination
                  v-if="totalItemOrder > limit"
                  v-model="currentPageOrder"
                  :length="getTotalItem(totalItemOrder, limit)"
                  class="justify-sm-end"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
              />
            </v-col>
          </v-col>

          <v-col cols="12" v-if="tabIndex === 2">
            <contact-card :customers="customers"/>

            <v-col cols="12" sm="6">
              <v-pagination
                  v-if="totalItem > limit"
                  v-model="currentPage"
                  :length="getTotalItem(totalItem, limit)"
                  class="justify-sm-end"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
              />
            </v-col>
          </v-col>

          <v-col cols="12" v-if="tabIndex === 3">
            <active-code-card :customers="customers"/>
          </v-col>
        </v-row>
      </validation-observer>
    </base-material-card>
  </v-container>
</template>

<script>
import * as moment from 'moment'
import AgencyDetailCard from './components/AgencyDetailCard';
import ContactCard from './components/ContactCard';
import OrderTableV1 from './components/OrderTableV1';
import RepositoryFactory from '../../repositories/RepositoryFactory';
import CardFilterForm from './components/CardFilterForm';
import ActiveCodeCard from "./components/activeCodeTab/ActiveCodeCard";
const AgencyRepository = RepositoryFactory.get('agency')
import { downloadFile } from '../../helpers/utils';

export default {
  components: {
    ActiveCodeCard,
    AgencyDetailCard,
    OrderTableV1,
    ContactCard,
    CardFilterForm
  },
  data() {
    return {
      usersAgency: [],
      dataForm: {},
      loadedContact: false,
      tabs: ['Thông tin đại lý', 'Đơn hàng', 'Khách hàng đại lý', 'Danh sách mã'],
      listPhoneRelated: '',
      tabIndex: 0,
      orders: [],
      customers: [],
      id: 0,
      totalPrice: 0,
      contactStatusAgency: [],
      currentPage: 1,
      currentPageOrder: 1,
      limit: 10,
      totalItem: 0,
      totalItemOrder: 0,
      openMenu: false
    };
  },
  props: {
    filterForm: {
      default: () => ({})
    }
  },
  computed: {},
  watch: {
    currentPage: {
      handler () {
        this.getCustomerList()
      },
    },
    currentPageOrder: {
      handler () {
        this.getOrderList()
        // Bus.$on('order-list-filter', (filterForm) => {
        //   this.getOrderList(filterForm)
        // })
      },
    },
    limit: {
      handler () {
        if (this.currentPage === 1) {
          this.getCustomerList()
        } else {
          this.currentPage = 1
        }
        if (this.currentPageOrder === 1) {
          this.getOrderList()
        } else {
          this.currentPageOrder = 1
        }
      },
    },
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.id = parseInt(this.$route.params.id, 10)
    }
    const tabIndex = _.get(this, '$route.query.tabIndex', '');

    if (tabIndex !== '') {
      this.tabIndex = parseInt(tabIndex)
    }
    if (this.tabIndex === 1) {
      this.getOrderList()
    }
    if (this.tabIndex === 2) {
      this.getCustomerList()
    }
  },
  async created() {
    this.dataForm = {
      order: {},
      position: 'other',
      contactSourceIds: [],
      groupIds: [],
      customers: [
        {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        }
      ]
    };
    Bus.$on('close-filter-form-agency', () => {
      this.openMenu = false;
    })
    this.appLoadingData(true)
    await Promise.all([
      this.getUsersAgency(),
      this.getListContactStatusAgency()
    ]);
    this.appLoadingData(false)

    //event update order in agency
    Bus.$on('order-tab-filter', (filter) => {
      this.getOrderList();
    })

    // event search order in agency
    Bus.$on('order-list-filter', (filterForm) => {
      this.getOrderList(filterForm)
    })

    //print order code
    Bus.$on('print-code-in-order', activeCodeList => {
      this.printActiveCode(activeCodeList)
    });
  },
  beforeDestroy() {
    Bus.$off('order-list-filter');
    Bus.$off('order-tab-filter');
  },
  methods: {
    remove(item) {
      const filterFormTemp = this.filterForm;
      const index = filterFormTemp.userIds.indexOf(item.id);
      if (index >= 0) filterFormTemp.userIds.splice(index, 1);
    },
    changeTab() {
      if (this.tabIndex === 1) {
        this.getOrderList()
      }
      if (this.tabIndex === 2) {
        this.getCustomerList()
      }
    },
    async getOrderList(filterForm = {}) {
      const loading = this.$loading.show();
      const response = await AgencyRepository.getOrderList({
        limit: this.limit,
        page: this.currentPageOrder - 1,
        agencyId: this.id,
        ...filterForm
      });

      loading.hide()
      if (response.success) {
        this.totalItemOrder = response.data.totalItem
        let listOrder = _.get(response, 'data.data', [])
        this.orders = listOrder.map(item => {
          return {
            ...item,
            rowspan: item.products && item.products.length ? item.products.length : 1
          }
        })
        this.totalPrice = _.get(response, 'data.totalPrice', [])
      }
    },
    async getCustomerList(filterForm = {}) {
      const loading = this.$loading.show();
      const response = await AgencyRepository.getContact({
        limit: this.limit,
        page: this.currentPage - 1,
        agencyId: this.id,
        ...filterForm
      });

      loading.hide()
      if (response.success) {
        this.totalItem = response.totalItem
        this.customers = _.get(response, 'data', [])
      }
    },
    clickAddOrder() {
      let self = this
      if (this.dataForm.mainId) {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + self.dataForm.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = self.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: self.dataForm.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        this.$router.push({
          name: 'AgencyOrderCreate',
          params: { id: _.get(this, '$route.params.id', '') }
        });
      }
    },
    async getUsersAgency() {
      const userAgencyList = await AgencyRepository.getListUserByPermission({
        model:'agency-user', action:'read'
      })
      if (userAgencyList.data && userAgencyList.data.success) {
        this.usersAgency = _.get(userAgencyList, 'data.data', [])
      }
    },
    async getListContactStatusAgency() {
      const res = await AgencyRepository.listStatus({limit: 1000})
      if (res.success) {
        this.contactStatusAgency = _.get(res, 'data', [])
      }
    },
    async exportContactForAgency () {
      this.appLoadingData(true);
      let params = {
        agencyId: this.id
      }
      const res = await AgencyRepository.exportContactForOrder(params);
      this.appLoadingData(false)
      if (res.data && res.success) {
        this.$swal({
          text: 'Tải xuống dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        })
        await downloadFile(_.get(res, 'data.csvFile', ''), _.get(res, 'data.fileName', ''));
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
    },
    initWindowPrint() {
      let mywindow = window.open();
      mywindow.document.write('<html><head><title>In_ma_'+moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
        +'</title><style></style><link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"></head><body style="margin:0 !important">');
      return mywindow;
    },
    endWindowPrint(mywindow, html) {
      mywindow.document.write(html);
      mywindow.document.write('</body></html>');
      mywindow.document.querySelector('style').textContent += `
        @media print{
          @page{
            size: a4 landscape;margin:0
          }
        }
      `
      mywindow.document.close(); // necessary for IE >= 10 
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      mywindow.close();
      return true;
    },
    printActiveCode(activeCodeList) {
      var html = ""

      if (Array.isArray(activeCodeList)) {
        if (activeCodeList.length > 0) {
          var mywindow = this.initWindowPrint()
          activeCodeList.forEach((item,key) => {
            if (item.status !== 'inactive') {
              html += '<div class="page" id="printSection" style="font-family:Roboto,sans-serif;width:297mm;height:209mm">';
              html += '<h2 style="padding-top:67mm;padding-left:32px;font-size:27px"><b>MÃ KÍCH HOẠT - '
                +item.numberOfSubject+ ' MÔN</b></h2>';
              html += '<h1 style="padding-top:5mm;padding-left:80px"><b>' + item.activeCode + '</b></h1>';
              html += '<p style="padding-left:27px;font-size:15px">*Thời gian học kể từ ngày kích hoạt: '
                +item.studyTimeText+'</p>';
              html += '<p style="padding-top:90mm;padding-left:10px">'+(parseInt(key)+1)+'</p></div>'
            }
          })
          this.endWindowPrint(mywindow, html)
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Đơn không có mã hoặc đã hủy'
          });
        }
      } else {
        var mywindow = this.initWindowPrint()
        html += '<div class="page" id="printSection" style="font-family:Roboto,sans-serif;width:297mm;height:209mm">';
        html += '<h2 style="padding-top:67mm;padding-left:32px;font-size:27px"><b>MÃ KÍCH HOẠT - '
          +activeCodeList.numberOfSubject+ ' MÔN</b></h2>';
        html += '<h1 style="padding-top:5mm;padding-left:80px"><b>' + activeCodeList.activeCode + '</b></h1>';
        html += '<p style="padding-left:27px;font-size:15px">*Thời gian học kể từ ngày kích hoạt: '
          +activeCodeList.studyTimeText+'</p>';
        html += '<p style="padding-top:90mm;padding-left:10px">1</p></div>'
        this.endWindowPrint(mywindow, html)
      }
    },
  },
};
</script>
<style scoped>
.menu__customer--filter {
  top: calc(11%) !important;
}
/deep/ .theme--light .v-data-table.active-code-table table thead tr th {
  color: #ffffff !important;
}
</style>